import React, {useMemo} from 'react';
import {MessageDescriptor, useIntl} from 'react-intl';
import cn from 'classnames';

import Button from 'brandComponents/Button';

import messages from '../../messages';

import {IStoreButtonsProps} from './IStoreButtons';

import styles from './StoreButtons.module.scss';

const StoreButtons = ({onToggle, activeView}: IStoreButtonsProps) => {
	const intl = useIntl();

	const buttons = useMemo<Array<{key: IStoreButtonsProps['activeView']; label: MessageDescriptor}>>(
		() => [
			{
				key: 'map',
				label: messages.resultsMap,
			},
			{
				key: 'list',
				label: messages.list,
			},
		],
		[],
	);

	return (
		<div className={styles['store-locator-buttons']}>
			{buttons.map((button) => (
				<Button
					key={button.key}
					variant="tertiary"
					onClick={() => onToggle(button.key)}
					classNames={cn([
						styles['store-locator-buttons__toggle'],
						{[styles['store-locator-buttons__toggle--active']]: activeView === button.key},
					])}
				>
					{intl.formatMessage(button.label)}
				</Button>
			))}
		</div>
	);
};

export default StoreButtons;
